import { useCallback, useState } from "react";

type ReturnType = {
  height: string;
  handleMouseDown: (_e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};
export const useResizable = (): ReturnType => {
  const minDrawerWidth = 300;
  const maxDrawerWidth = 600;

  const [height, setHeight] = useState("300px");

  const handleMouseDown = (
    _e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
  document &&  document.addEventListener("mouseup", handleMouseUp, true);
  document &&  document.addEventListener("mousemove", handleMouseMove, true);
  };

  const handleMouseUp = () => {
   document && document.removeEventListener("mouseup", handleMouseUp, true);
   document && document.removeEventListener("mousemove", handleMouseMove, true);
  };

  const handleMouseMove = useCallback((e: MouseEvent) => {
    const newHeight = document.body.offsetHeight - e.clientY;
    if (newHeight > minDrawerWidth && newHeight < maxDrawerWidth) {
      setHeight(`${newHeight}px`);
    }
  }, []);

  return { height, handleMouseDown };
};
